<template>
  <div class="personal_table">
    <div class="table">
      <slot name="thead"></slot>
      <slot name="tbody"></slot>
    </div>
  </div>
</template>
<style lang="scss">
.personal_table {
  .table {
    position: relative;
    max-width: 100%;
    width: 100%;
    min-height: 100px;
    padding-bottom:60px;
  }
  .table_inner {
    min-width: 300px;
  }
  table {
    font-size: 14px;
    text-align: left;
    table-layout: fixed;
    width: 100%;
    thead {
      font-weight: bold;
      background: #fff;
    }
    td,
    th {
      position: relative;
      padding: 20px 10px;
      border-bottom: 1px solid #e1e3ee;
    }
    th {
      white-space: nowrap;
    }

    td {
      white-space: pre-line;
    }
    > tbody {
      > tr {
        &:hover {
          background: #f8faff;
        }
      }
    }
    .text_center {
      text-align: center;
    }
  }
}
</style>
<script>
import FixHead from "./components/TableFixHead";
import DefaultTable from "./components/Table";
export default {
  name: "default_table",
  components: {
    FixHead,
    DefaultTable,
  },
  props: {
    thead: Array,
    tableData: Array,
    outterHeight: Number,
  },
  data() {
    return {};
  },
  computed: {
    name() {
      return this.$store.state.name;
    },
  },
  mounted() {},
};
</script>
